import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { navItems } from '../mock';
import { Button } from './ui/button';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navHref = (anchor) => isHome ? anchor : `/${anchor}`;

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-[#FAFAF5]/85 backdrop-blur-md border-b border-[#E8E5DC]'
          : 'bg-[#FAFAF5] border-b border-transparent'
      }`}
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 group">
          <img
            src="/esgine-logo.png"
            alt="ESGine"
            className="w-10 h-10 object-contain"
          />
          <div className="font-display text-[22px] leading-none tracking-tight text-[#0B1F2D]">
            ESGine<sup style={{fontSize:'9px', verticalAlign:'middle', marginLeft:'2px'}}>®</sup>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {navItems.map((it) => (
            <Link
              key={it.label}
              to={navHref(it.href)}
              className="text-[13.5px] text-[#0B1F2D]/70 hover:text-[#0B1F2D] transition-colors link-underline"
            >
              {it.label}
            </Link>
          ))}
        </nav>

        {/* CTAs */}
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/login" className="text-[13.5px] text-[#0B1F2D]/70 hover:text-[#0B1F2D] transition-colors">
            Client Login
          </Link>
          <Button
            asChild
            className="bg-[#0B1F2D] hover:bg-[#0B1F2D]/90 text-[#FAFAF5] rounded-full h-10 px-5 text-[13px] font-medium"
          >
            <Link to={navHref('#contact')} className="inline-flex items-center gap-1.5">
              Request Access
              <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
          </Button>
        </div>

        {/* Mobile toggle */}
        <button
          className="lg:hidden w-10 h-10 rounded-md border border-[#E8E5DC] flex items-center justify-center"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-[#E8E5DC] bg-[#FAFAF5]">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navItems.map((it) => (
              <Link
                key={it.label}
                to={navHref(it.href)}
                onClick={() => setOpen(false)}
                className="text-[15px] text-[#0B1F2D]/80"
              >
                {it.label}
              </Link>
            ))}
            <Link
              to={navHref('#contact')}
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center bg-[#0B1F2D] text-[#FAFAF5] rounded-full h-11 items-center px-5 text-[13px]"
            >
              Request Access
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
